import React from 'react';
import { ABOUT_CONTENT } from '../data/mockData';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useGoToContact } from '../hooks/useGoToContact';

const AboutSection = () => {
  const goToContact = useGoToContact();

  return (
    <section id="about" className="bg-[#FDFEFA] py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-start">
          {/* Left Column - Big Headline */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-[#242326] text-3xl md:text-5xl lg:text-[56px] font-light leading-[1.15] tracking-tight font-['Inter']">
              {ABOUT_CONTENT.headline}
            </h2>
          </motion.div>

          {/* Right Column - Description */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="pt-0 lg:pt-2"
          >
            <p className="text-[#4A4A48] text-lg md:text-xl leading-relaxed font-['Lato'] font-light mb-6">
              {ABOUT_CONTENT.description}
            </p>
            <button
              onClick={goToContact}
              data-testid="about-contact-cta"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-[#242326]/20 text-[#242326] text-[15px] font-light hover:bg-[#242326] hover:text-white transition-all duration-300 font-['Inter'] group"
            >
              {ABOUT_CONTENT.cta.label}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
